export default "__VITE_ASSET__DPLRhGDb__"